import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import {
  shouldClearUploadedBatchAttachment,
  type UploadedBatchScopeObservation,
} from '~/components/v2/components/workspace/workspace-agent-panel/uploaded-batch-offer/shouldClearUploadedBatchAttachment';
import { useUploadedBatchOfferStore } from '~/components/v2/components/workspace/workspace-agent-panel/uploaded-batch-offer/useUploadedBatchOfferStore';
import { useViewsSelectAllStore } from '~/components/v2/store/features/views/useViewsSelectAllStore';
import { selectedClipItemsSelector } from '~/store/selectedItems/selectors';

/** Drops the uploaded-batch attachment once a real selection appears or an existing task opens. */
export const usePrivateClearUploadedBatchOnScopeChange = (sessionId: string | null) => {
  const selectedClipCount = useSelector(selectedClipItemsSelector).length;
  const selectAll = useViewsSelectAllStore((state) => state.selectAll);
  const previousRef = useRef<UploadedBatchScopeObservation | null>(null);

  useEffect(() => {
    const next = { selectAll, selectedClipCount, sessionId };

    if (shouldClearUploadedBatchAttachment(previousRef.current, next)) {
      useUploadedBatchOfferStore.getState().clearAttachedBatch();
    }

    previousRef.current = next;
  }, [selectAll, selectedClipCount, sessionId]);
};
